import React, { useCallback } from "react";
import { useWorkflowContext } from "../WorkflowContext/WorkflowContext";
import MarkdownViewer from "../../JupyterNotebook/MarkdownViewer/MarkdownViewer";
import BlockOutput from "../../JupyterNotebook/BlockOutput/BlockOutput";
import CodeEditorInviewer from "../../JupyterNotebook/CodeEditor/CodeEditorInviewer";
import { MODIFY_CODE_CELL, MODIFY_CHAT_HISTORY_CELL } from "../WorkflowContext/reducer";
import ChatWithCode from "../../JupyterNotebook/ChatWithCode/ChatWithCode";
const JupyterNotebook = (props) => {
    console.log("notebook")
    const {
        Display_code_cells = [0, -1],
        Display_output_cells = [0, -1],
        RunCodeCell = (cellIndex, code) => { console.log("Run Cell: ", cellIndex) },
        StopExecution = () => { console.log("Stop Code Execution!") },
        hideOutputBlocks = false,
        hideCodeBlocks = false,
    } = props;
    const { state, dispatch } = useWorkflowContext();
    console.log(state)
    const [selectedCell, setSelectedCell] = React.useState(-1);
    const [cwcIndex, setCwcIndex] = React.useState(-1);
    const [viewChatWithCode, setViewChatWithCode] = React.useState(false);
    const [debugCellOutput, setDebugCellOutput] = React.useState({});
    const selectDiv = (e) => {
        setSelectedCell(e);
    }
    const ChangeCwcView = React.useCallback((value) => { setViewChatWithCode(value); }, []);
    const selectedCellRef = React.useRef(null);
    const containerRef = React.useRef(null);

    function classNames(...args) {
        return args.filter(Boolean).join(' ')
    }
    const SetCwcCellIndex = useCallback((cellIndex) => {
        setCwcIndex(cellIndex);
        setSelectedCell(cellIndex);
        setViewChatWithCode(true);
    }, []);
    const handleScrollOnfocus = async () => {
        await new Promise(resolve => setTimeout(resolve, 200));
        if (selectedCellRef.current && containerRef.current) {
            const containerHeight = containerRef.current.clientHeight;
            const selectedCellOffsetTop = selectedCellRef.current.offsetTop;
            const selectedCellHeight = selectedCellRef.current.clientHeight;
            const scrollPosition = selectedCellOffsetTop - containerHeight + selectedCellHeight - 200;
            if (scrollPosition > containerRef.current.scrollTop) {
                containerRef.current.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }
        }
    }
    const selectNextCodeCell = React.useCallback((cellIndex) => {
        for (let i = cellIndex + 1; i < state.notebook['cells'].length; i++) {
            if ('cell_type' in state.notebook['cells'][i] && state.notebook['cells'][i]['cell_type'] === "code") {
                selectDiv(i);
                if (selectedCellRef.current && containerRef.current) {
                    handleScrollOnfocus();
                }
                return;
            }
        }
    }, [state.notebook?.cells?.length])

    // removing errors***************
    const modifyJupyterNotebook = React.useCallback((cellIndex, value) => {
        const code = value.split(/\r?\n/).map((line, index, array) => index === array.length - 1 ? line : line + '\n');
        dispatch({ type: MODIFY_CODE_CELL, payload: { cellIndex: cellIndex, code: code, modifyCwcContext: true } });
    }, [])
    const onChangeJupyterNotebookCode = useCallback((cellIndex, value) => {
        modifyJupyterNotebook(cellIndex, value);
    }, []);
    const debugOutputError = useCallback(() => { }, []);

    let rawIpynb = state.notebook;
    React.useEffect(() => {
        rawIpynb = state.notebook;
    }, [state]);
    const chatHistory = state.cwc;
    const modifyChatHistory = React.useCallback((cellIndex, cellChatHistory) => {
        dispatch({ type: MODIFY_CHAT_HISTORY_CELL, payload: { cellIndex: cellIndex, cellChatHistory: cellChatHistory } });
    }, [])

    const clearChatHistory = React.useCallback((cellIndex) => {
        modifyChatHistory(cellIndex, {
            "isLoading": false,
            "context": rawIpynb.cells[cellIndex]['source'].join(''),
            "chat": [{ type: "outgoing", isCode: true, "message": rawIpynb.cells[cellIndex]['source'].join('') }],
            "debug": [{ type: "outgoing", isCode: true, "message": rawIpynb.cells[cellIndex]['source'].join('') }],
        });
    }, [])
    if (!state.notebook || !('cells' in state.notebook)) return <div>Invalid Notebook</div>
    const cellExecutionDetails = state.cellExecutionDetails;
    const DisplayCellsList = rawIpynb['cells']?.slice(Display_code_cells[0], Display_code_cells[1] >= 0 ? Display_code_cells[1] : rawIpynb['cells'].length).map((_, index) => index + Display_code_cells[0]);;
    const OutputCellList = rawIpynb['cells']?.slice(Display_output_cells[0], Display_output_cells[1] >= 0 ? Display_output_cells[1] : rawIpynb['cells'].length).map((_, index) => index + Display_output_cells[0]);;
    // ***********************************
    return (
        <>
            <div className="jupyter-container-workflow" style={viewChatWithCode ? { justifyContent: "flex-start" } : { justifyContent: "flex-start" }}>
                <div className="jupyter-viewer custom-scrollbar" ref={containerRef}>
                    {rawIpynb['cells'].map((cell, index) => {
                        const cellindex = index
                        if (!DisplayCellsList.includes(cellindex) && !OutputCellList.includes(cellindex)) return (null);
                        return (
                            <div
                                key={cellindex}
                                className={classNames('block', selectedCell === cellindex && 'focused-div')}
                                ref={selectedCell === index ? selectedCellRef : null}
                            >
                                {!('cell_type' in cell) ? null :
                                    // block source
                                    <>{(cell['cell_type'] === 'markdown') ? <MarkdownViewer cell={cell} /> :
                                        <> {(DisplayCellsList.includes(cellindex)) &&
                                            <div className="cell-with-toolbar" style={hideCodeBlocks === true ? { display: "none" } : {}}>
                                                <div onClick={() => selectDiv(cellindex)} key={cellindex}>
                                                    <CodeEditorInviewer
                                                        cellExecutionDetails={cellExecutionDetails.length >= cellindex ? cellExecutionDetails[cellindex] : null}
                                                        StopExecution={StopExecution}
                                                        code={cell['source']}
                                                        isOnFocus={selectedCell === cellindex}
                                                        onChangeCode={onChangeJupyterNotebookCode}
                                                        cellIndex={cellindex}
                                                        RunCodeCell={RunCodeCell}
                                                        selectNextCodeCell={selectNextCodeCell}
                                                    />
                                                </div>
                                                <div className="cell-toolbar">
                                                    <button onClick={() => SetCwcCellIndex(cellindex)}>CHAT WITH CODE</button>
                                                </div>
                                            </div>
                                        }
                                        </>
                                    }</>
                                }
                                {!('outputs' in cell) ? null :
                                    // block output
                                    <>
                                        {OutputCellList.includes(cellindex) &&
                                            <div onClick={() => selectDiv(cellindex)} key={cellindex}>
                                                <BlockOutput
                                                    outputs={cell.outputs}
                                                    debugOutputError={debugOutputError}
                                                    cellIndex={cellindex}
                                                />
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                        )
                    })}
                </div>
                {cwcIndex >= 0 && rawIpynb['cells'][cwcIndex] && viewChatWithCode &&
                    <>
                        {
                            <div className={classNames("cwc-side-drawer", !viewChatWithCode && "close-drawer")}>
                                <ChatWithCode
                                    cwcIndex={cwcIndex}
                                    ChangeCwcView={ChangeCwcView}
                                    cwcCellHistory={chatHistory[cwcIndex]}
                                    passChatHistory={chatHistory}
                                    modifyJupyterNotebook={modifyJupyterNotebook}
                                    clearChatHistory={clearChatHistory}
                                    modifyChatHistory={modifyChatHistory}
                                    debugCellOutput={(debugCellOutput && debugCellOutput.cellIndex === cwcIndex) ? debugCellOutput.error : ""}
                                    setDebugCellOutput={setDebugCellOutput}
                                />
                            </div>
                        }
                    </>
                }
            </div>
        </>
    )

}

export default JupyterNotebook;